import SlimSelect from 'slim-select';

window.choicesArray = [];

window.initChoices = function initChoices(elementsArr) {
  const choicesDOM = document.querySelector(`${elementsArr}`);
  console.log(choicesDOM);
  
  if (choicesDOM) {
    const choicesArr = document.querySelectorAll(`${elementsArr}`);
    console.log(choicesArr);
    
    for (let i = 0; i < choicesArr.length; i++) {
      console.log('init');
      const parentContainer = choicesArr[i].parentNode;
      /*const list = parentContainer.querySelector(".default-select__list");*/

      const choices = new Choices(choicesArr[i], {
        searchEnabled: false,
        itemSelectText: '',
        placeholder: true,
        searchPlaceholderValue: 'Search',
        shouldSort: false,
      });
      choicesArray.push(choices);

      const choicesMultipleElement = parentContainer.querySelector(".choices[data-type='select-multiple']");

      if (choicesMultipleElement) {
        choicesMultipleElement.addEventListener('click', () => {
          if (parentContainer.querySelector('.is-open')) {
            choices.hideDropdown();
          }
        });
      }

      /* New multiselect logic */
      if (choicesArr[i].multiple && choicesArr[i].hasAttribute('data-multiple-list-logic')) {
        let optionName = null;
        let optionValue = null;

        const multiplePlaceholder = parentContainer.querySelector('.choices__list--multiple');

        const list = document.createElement('ul');
        list.className = 'meta-select__list';
        parentContainer.appendChild(list);

        function createListItem(optionName, optionValue) {
          const listItem = document.createElement('li');
          listItem.setAttribute('data-val', optionValue);
          listItem.innerHTML = `${optionName}`;
          listItem.classList.add('meta-select__list-item');
          list.appendChild(listItem);

          listItem.addEventListener('click', () => {
            handleListItemClick(listItem);
          });
        }
        function handleSelectedOptions() {
          list.innerHTML = '';

          const selectedOptions = Array.from(choicesArr[i].selectedOptions);

          if (selectedOptions.length >= 1) {
            list.classList.add('is-visible');
          } else {
            list.classList.remove('is-visible');
          }

          if (selectedOptions.length === 0 && !choicesArr[i].multiple) {
            choices.setChoiceByValue('');
          }

          selectedOptions.forEach(function (option) {
            optionName = option.textContent;
            optionValue = option.value;
            if (optionName !== 'Select') {
              createListItem(optionName, optionValue);
            }
          });

          const listArr = list.querySelectorAll('.meta-select__list-item');
          if (listArr.length === 1) {
            multiplePlaceholder.textContent = optionName;
          } else if (listArr.length >= 2) {
            multiplePlaceholder.textContent = `Selected ${listArr.length} items`;
          } else {
            multiplePlaceholder.textContent = 'Select';
          }
        }

        function handleListItemClick(listItem) {
          const optionValue = listItem.getAttribute('data-val');

          choices.removeActiveItemsByValue(optionValue);
          handleSelectedOptions();
        }

        handleSelectedOptions();

        choicesArr[i].addEventListener('change', function () {
          handleSelectedOptions();
        });

        list.addEventListener('click', function (event) {
          const liElement = event.target.closest('.meta-select__list-item');
          if (liElement) {
            handleListItemClick(liElement);
          }
        });
      }
    }
  }
};

window.initChoices('[data-choices]');

window.getChoice = function getChoice(select) {
  let selectEl = typeof select === 'object' ? select : document.querySelector(select);
  let choicesArr = window.choicesArray;
  let targetChoice;
  if (choicesArr) {
    window.choicesArray.forEach((choices) => {
      let choicesSelect = choices.passedElement.element;
      if (choicesSelect == selectEl) {
        targetChoice = choices;
      }
    });
  }
  return targetChoice;
};

window.resetChoice = function resetChoice(select) {
  let choice = getChoice(select);
  if (choice) {
    let startValue = choice.config.choices[0].value;
    choice.setChoiceByValue(startValue);
  }
};

document.querySelector('.btn-meta')?.addEventListener('click', () => {
  setTimeout(() => {
    window.initChoices('#download-popup [data-choices]');
  }, 100);
})

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    initChoices('[data-choices]');
  }, 500);
});

window.initSlimSelect = function initSlimSelect(elementsArr) {
  const SlimSelectDOM = document.querySelector(elementsArr);
  if (SlimSelectDOM) {
    const SlimSelectArr = document.querySelectorAll(`${elementsArr}`);
    for (let i = 0; i < SlimSelectArr.length; i++) {
      const selectElement = SlimSelectArr[i];
      const parentContainer = SlimSelectArr[i].parentNode;
      const label = parentContainer.querySelector('label');

      const initialClasses = [...parentContainer.classList];

      const SlimSelectInit = new SlimSelect({
        select: selectElement,
        settings: {
          showSearch: false,
          focusSearch: false,
          searchHighlight: false,
        },
      });

      if (label) {
        label.addEventListener('click', () => {
          SlimSelectInit.open();
        });
      }

      if (selectElement.classList.contains('hidden-slim-select-on-scroll')) {
        const simpleBarWrapper = selectElement.closest(
            '.simplebar-content-wrapper'
        );
        if (simpleBarWrapper) {
          simpleBarWrapper.addEventListener('scroll', () => {
            SlimSelectInit.close();
          });
        }

        document.addEventListener('scroll', () => {
          SlimSelectInit.close();
        });

        document.addEventListener('touchmove', () => {
          SlimSelectInit.close();
        });
      }

      selectElement.addEventListener('change', function () {
        const selectedOption =
            selectElement.options[selectElement.selectedIndex];
        const selectedOptionClasses = [...selectedOption.classList];

        parentContainer.className = initialClasses.join(' ');

        selectedOptionClasses.forEach((className) => {
          parentContainer.classList.add(className);
        });
      });

      const selectedOption = selectElement.options[selectElement.selectedIndex];
      const selectedOptionClasses = [...selectedOption.classList];

      parentContainer.className = initialClasses.join(' ');

      selectedOptionClasses.forEach((className) => {
        parentContainer.classList.add(className);
      });
    }
  }
};

initSlimSelect('#site [data-slim-select]');


